<template>
    <div class="listitem"
         :class="containerClass"
    >
        <article class="article product-item h-100">
            <a :href="product.url" :title="product.name" class="h-100 d-flex flex-direction-column">
                <div class="article-media article-media-2-by-3 my-position-relative">
                    <div class="product-image-2-by-3 my-position-relative">
                        <badges :product="product" />

                        <div v-if="product.showVideoInList && product.video && !isPlusSize">
                            <video :src="product.video.url"
                                   style="aspect-ratio: 196 / 294; object-fit: contain;"
                                   playsinline
                                   autoplay
                                   loop
                                   muted
                            ></video>
                        </div>

                        <div v-else>
                            <responsive-image
                                v-if="product.coverImage"
                                :media="product.coverImage"
                                :alt="product.name"
                                classes="product-image"
                                style="margin-bottom: auto; margin-top: auto;"
                            />
                        </div>

                        <responsive-image
                            v-if="product.modelImage"
                            :media="product.modelImage"
                            :alt="product.name"
                            classes="product-hover product-image"
                            style="margin-bottom: auto; margin-top: auto;"
                        />
                    </div>
                </div>

                <div class="article-header text-center">
                    <h3 class="article-title"
                        style="margin-bottom: 0; font-size: 1.1rem;"
                    >
                        {{ product.name }}
                    </h3>

                    <div class="article-price"
                         style="margin-bottom: 0;"
                    >
                        <div :class="{promo: product.isDiscounted }">
                            <span>
                                {{ product.price | currency(currencyFormat(product.currency)) }}
                            </span>
                            <del v-if="product.isDiscounted">
                                {{ product.originalPrice | currency(currencyFormat(product.currency)) }}
                            </del>
                        </div>
                    </div>
                </div>

                <div class="article-toolbar my-2 d-flex flex-direction-column"
                     style="flex: 1; margin: 0;"
                >
                    <size-selector
                        :sizes="product.sizes"
                        :selected-size.sync="selectedSize"
                        :show-label="false"
                    ></size-selector>

                    <ProductItemVariantsPicker
                        :product="product"
                        :variants="product.variantsData"
                    ></ProductItemVariantsPicker>

                    <div class="mt-auto">
                        <add-to-cart
                            :id='{ type: product.type, identifier: selectedSize ? selectedSize.product_id : product.id}'
                            :data-toggle="selectedSize ? null : 'tooltip'"
                            data-placement="top"
                            title="Tooltip on top"
                            :disabled="product.sizes.length > 0 ? ! selectedSize : false">
                            {{ __('Kosárba') }}
                        </add-to-cart>

                        <add-to-wishlist-collection
                            :item='{ type: product.type, identifier: product.id }'
                            :exist-in-the-list-collection='product.existInTheWishlistCollection'
                            list-collection="favourites"
                            :added-message="__('Product added to your wishlist!')"
                            :removed-message="__('Product removed from your wishlist.')"
                        />
                    </div>
                </div>
            </a>
        </article>
    </div>
</template>

<script>
import ResponsiveImage from '../../mediaLibrary/ResponsiveImage';
import SizeSelector from './SizeSelector';
import Badges from './Badges';
import currencyFormatter from '../../mixins/currencyFormatter'
import ProductItemVariantsPicker from './ProductItemVariantsPicker'

export default {
    name: 'ProductItem',
    mixins: [currencyFormatter],
    components: {
        ProductItemVariantsPicker,
        Badges,
        SizeSelector,
        ResponsiveImage
    },
    props: {
        product: {
            type: Object
        },

        isPlusSize: {
            type: Boolean,
            default: () => false,
        },

        containerClass: {
            type: String,
            default: () => 'h-auto',
        }
    },

    data() {
        return {
            selectedSize: null,
            showDetails: false,
        }
    },

    watch: {
        selectedSize() {
            this.product.price = this.selectedSize.price
            this.product.originalPrice = this.selectedSize.originalPrice
        }
    },

    methods: {
        navigateToProductPage() {
            this.$route.push({path: this.product.url})
        },

        plusSizeProduct() {
            return this.product.sizes.find(size => size.isPlusSize);
        }
    },

    mounted() {
        if(this.isPlusSize) {
            this.selectedSize = this.plusSizeProduct();
        }
    },
}
</script>

<style scoped>

</style>
